import { routes as home } from '@/pages/home';
import { routes as dashboard } from '@/pages/dashboard';
import { routes as sobre } from '@/pages/sobre';
import { routes as mailing } from '@/pages/landing';
import { routes as pesquisa } from '@/pages/pesquisa';
import { routes as erro } from '@/pages/erro';

export default [
    ...home,
    ...dashboard,
    ...sobre,
    ...mailing,
    ...pesquisa,
    ...erro,
    {
        // DX-2201: link de acesso direto curto (baseURL + código de 9 caracteres),
        // ex: https://dominio.com.br/O2ZaoswZl. Precisa ficar depois de todas as
        // rotas específicas (dashboard, /acesso/:mailing, /sobre, etc.) e antes do
        // catch-all, já que o vue-router 3 casa rotas pela ordem de registro, não
        // por especificidade.
        path: "/:shortCode",
        component: () => import("@/modules/layout/HomeLayout"),
        children: [
            {
                path: "",
                name: "shortLinkAccess",
                component: () => import("@/pages/home/Home"),
            },
        ],
    },
    {
        path: "/:pathMatch(.*)",
        name: "notFound",
        component: () =>
          import("@/pages/NotFound"),
    },
];
